export default 'M0 4.5h24v-3H0zm3 6h18v-3H3zm-3 6h24v-3H0zm3 6h18v-3H3z';